export default __webpack_public_path__ + "static/media/title-recordKeepingIcon.0067dc08.svg";